import React, { useEffect } from 'react'
import Icon from './Icon'

const Alert = ({ message, type = 'error', onClose, autoHide = true, duration = 5000 }) => {
  useEffect(() => {
    if (autoHide && onClose) {
      const timer = setTimeout(() => {
        onClose()
      }, duration)
      return () => clearTimeout(timer)
    }
  }, [autoHide, onClose, duration])

  const getAlertStyles = () => {
    switch (type) {
      case 'success':
        return 'bg-green-100 border-green-500 text-green-700'
      case 'warning':
        return 'bg-yellow-100 border-yellow-500 text-yellow-700'
      case 'info':
        return 'bg-blue-100 border-blue-500 text-blue-700'
      case 'error':
      default:
        return 'bg-red-100 border-red-500 text-red-700'
    }
  }

  const getIconName = () => {
    switch (type) {
      case 'success':
        return 'check-mark'
      case 'warning':
        return 'warning-triangle'
      case 'info':
        return 'info-icon'
      case 'error':
      default:
        return 'alert'
    }
  }

  return (
    <div
      className={`fixed top-4 left-1/2 transform -translate-x-1/2 z-[1001] flex items-center p-4 mb-4 text-sm border rounded-lg ${getAlertStyles()} max-w-md w-full shadow-lg`}
      role="alert"
    >
      <Icon name={getIconName()} className="flex-shrink-0 size-4 mr-3" />
      <div className="flex-1 ml-4 font-semibold text-lg">{message}</div>
      {onClose && (
        <button
          type="button"
          className="ml-3 text-current hover:opacity-75 focus:outline-none"
          onClick={onClose}
          aria-label="Close alert"
        >
          <Icon name="close" className="size-4" />
        </button>
      )}
    </div>
  )
}

export default Alert
